// Validacion de email compartida por todos los formularios de la app.
//
// Existe porque el patron `email.includes('@')` estaba copiado en seis sitios y
// dejaba pasar "pepe@", "@gmail.com", "pe pe@gmail.com" y "pepe@gmail".
//
// Dos requisitos que justifican la forma del regex:
//   - Al menos tan estricta como la validacion nativa del navegador, porque los
//     formularios con noValidate no tienen otra barrera de cliente.
//   - Exige TLD. El navegador acepta "pepe@gmail", pero el backend lo rechaza por
//     formato; sin este filtro el error rebota del servidor y los modales lo
//     reescriben a "El email ya existe", que es falso y confunde al usuario.
export const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

// Vacio, null o undefined cuentan como invalido: los sitios que llaman aqui
// trataban ambos casos con el mismo mensaje.
export const isValidEmail = (value) =>
  typeof value === "string" && EMAIL_RE.test(value);
